export default __webpack_public_path__ + "static/media/cool_hand_upper.110e21ad.png";